/* ═══════════════════════════════════════════
   ΤΑ ΔΩΡΑ ΤΟΥ ΟΛΥΜΠΟΥ — LaGrecia.ch
   Game JavaScript MVP v1.0
   ═══════════════════════════════════════════ */

(function OlympusGame() {
  'use strict';

  // Config injected by Liquid (see at-olympus-game.liquid)
  const C = window.OlympusConfig || {};
  const SHOP_URL = C.shopUrl || 'https://lagrecia.ch';
  const IS_LOGGED_IN = C.isLoggedIn || false;
  const CUSTOMER_ID = C.customerId || '';
  const CUSTOMER_EMAIL = C.customerEmail || '';
  const LOCALE = C.locale || 'de';
  // Endpoint for server-side Shopify discount code creation (requires a backend/app)
  const DISCOUNT_ENDPOINT = C.discountEndpoint || null;

  // ── TRANSLATIONS ──────────────────────────
  const T = {
    de: {
      gameTitle: 'ΤΑ ΔΩΡΑ ΤΟΥ ΟΛΥΜΠΟΥ',
      gameSub: 'Wähle einen Gott & entdecke deine göttliche Belohnung',
      intro1: 'Willkommen auf dem Olymp.',
      intro2: 'Die Götter haben ein Geschenk für dich vorbereitet.',
      intro3: 'Wähle dein Schicksal.',
      openGates: 'Die Pforten öffnen',
      chooseDoor: 'Wähle eine Pforte des Olymps',
      divChances: 'Göttliche Chancen',
      athenaTitle: 'Athena stellt dir eine Frage',
      athenaMsg: 'Beweise deine Weisheit und erhalte eine göttliche Belohnung.',
      hermesTitle: 'Hermes — Göttlicher Bote',
      hermesMsg: 'Hermes kann die Pforten des Olymp wieder öffnen. Lade einen Freund ein.',
      closedTitle: 'Die Pforten des Olymp haben sich geschlossen.',
      closedSub: 'Hermes kann dich zurückführen. Lade einen Freund ein, schließe einen Kauf ab oder kehre morgen zurück.',
      earn1: 'Neues Kundenkonto erstellen', earn2: 'Newsletter abonnieren',
      earn3: 'Morgen zurückkehren', earn4: 'Freund einladen (Registrierung)',
      earn5: 'Freund kauft ein', earn6: 'Bestellung abschließen', earn7: 'Bestellung über CHF 80',
      inviteFriend: 'Freund einladen', shopNow: 'Griechisch einkaufen',
      myRewards: 'Meine Belohnungen', playAgain: 'Nochmal spielen',
      shareReward: 'Teilen', copyLink: 'Kopieren', copyInvite: 'Link kopieren',
      shareWA: '📱 WhatsApp', shareEmail: '✉️ E-Mail', backToGame: 'Zurück zum Spiel',
      rules: 'Spielregeln', privacy: 'Datenschutz', terms: 'Teilnahmebedingungen',
      legalNote: 'Kein Kauf erforderlich. Belohnungen nicht gegen Bargeld einlösbar. Max. 3 Chancen pro Tag.',
      refFriend1: 'Freund registriert sich', refFriend1r: '+1 göttliche Chance',
      refFriend2: 'Freund macht erste Bestellung', refFriend2r: '+3 Chancen + CHF 5 Guthaben',
      refFriend3: 'Dein Freund erhält', refFriend3r: '10% auf erste Bestellung',
      copied: 'Kopiert!', doorLabel: ['I', 'II', 'III'],
      drachmai: 'Olympische Drachmen',
      expiry: 'Gültig bis',
      minOrder: 'Mindestbestellwert',
      chancesLeft: 'Chancen übrig',
    },
    en: {
      gameTitle: 'THE GIFTS OF OLYMPUS',
      gameSub: 'Choose a god & discover your divine reward',
      intro1: 'Welcome to Olympus.',
      intro2: 'The gods have prepared a gift for you.',
      intro3: 'Choose your destiny.',
      openGates: 'Open the Gates',
      chooseDoor: 'Choose a Gate of Olympus',
      divChances: 'Divine Chances',
      athenaTitle: 'Athena asks you a question',
      athenaMsg: 'Prove your wisdom and receive a divine reward.',
      hermesTitle: 'Hermes — Divine Messenger',
      hermesMsg: 'Hermes can open the gates of Olympus once more. Invite a friend.',
      closedTitle: 'The Gates of Olympus are closed for today.',
      closedSub: 'Hermes can guide you back. Invite a friend, complete a purchase, or return tomorrow.',
      earn1: 'Create a customer account', earn2: 'Subscribe to newsletter',
      earn3: 'Return tomorrow', earn4: 'Invite friend (registers)',
      earn5: 'Friend makes purchase', earn6: 'Complete an order', earn7: 'Order over CHF 80',
      inviteFriend: 'Invite a friend', shopNow: 'Shop Greek products',
      myRewards: 'My rewards', playAgain: 'Play again',
      shareReward: 'Share', copyLink: 'Copy', copyInvite: 'Copy invite link',
      shareWA: '📱 WhatsApp', shareEmail: '✉️ Email', backToGame: 'Back to game',
      rules: 'Game Rules', privacy: 'Privacy Policy', terms: 'Terms',
      legalNote: 'No purchase required. Rewards not redeemable for cash. Max. 3 chances per day.',
      refFriend1: 'Friend registers', refFriend1r: '+1 divine chance',
      refFriend2: 'Friend makes first order', refFriend2r: '+3 chances + CHF 5 credit',
      refFriend3: 'Your friend receives', refFriend3r: '10% off first order',
      copied: 'Copied!', doorLabel: ['I', 'II', 'III'],
      drachmai: 'Olympic Drachmai',
      expiry: 'Valid until',
      minOrder: 'Min. order',
      chancesLeft: 'chances left',
    }
  };

  // ── GODS ──────────────────────────────────
  const GODS = [
    {
      id: 'zeus',
      name: { de: 'Δίας — Zeus', en: 'Δίας — Zeus' },
      short: { de: 'Zeus', en: 'Zeus' },
      title: { de: 'Herrscher des Olymp', en: 'Ruler of Olympus' },
      msg: { de: 'Zeus hat dir die Kraft des Olymp verliehen.', en: 'Zeus has granted you the Power of Olympus.' },
      color: '#C9972A', glow: 'rgba(201,151,42,.5)', cls: 'ol-zeus',
      svg: `<svg viewBox="0 0 60 60" width="60" height="60"><circle cx="30" cy="30" r="26" fill="none" stroke="#C9972A" stroke-width="1" opacity=".4"/><path d="M34 6 L18 30 h10 L13 54 L44 24 H32 Z" fill="rgba(201,151,42,.2)" stroke="#E8C76A" stroke-width="1.5"/><circle cx="30" cy="30" r="3" fill="#E8C76A" opacity=".4"/></svg>`,
    },
    {
      id: 'athena',
      name: { de: 'Αθηνά — Athena', en: 'Αθηνά — Athena' },
      short: { de: 'Athena', en: 'Athena' },
      title: { de: 'Göttin der Weisheit', en: 'Goddess of Wisdom' },
      msg: { de: 'Athena belohnt deine Weisheit.', en: 'Athena rewards your wisdom.' },
      color: '#A8C4D0', glow: 'rgba(168,196,208,.4)', cls: 'ol-athena', hasQuiz: true,
      svg: `<svg viewBox="0 0 60 60" width="60" height="60"><circle cx="30" cy="30" r="26" fill="none" stroke="#A8C4D0" stroke-width="1" opacity=".4"/><circle cx="22" cy="27" r="7" fill="none" stroke="#A8C4D0" stroke-width="1.3"/><circle cx="38" cy="27" r="7" fill="none" stroke="#A8C4D0" stroke-width="1.3"/><circle cx="22" cy="27" r="2.5" fill="#A8C4D0"/><circle cx="38" cy="27" r="2.5" fill="#A8C4D0"/><path d="M26 39 Q30 46 34 39" fill="none" stroke="#A8C4D0" stroke-width="1.3"/><path d="M17 13 L22 21M43 13 L38 21" stroke="#A8C4D0" stroke-width="1.2"/><path d="M7 29 L13 27 L7 33z" fill="#A8C4D0" opacity=".7"/><path d="M53 29 L47 27 L53 33z" fill="#A8C4D0" opacity=".7"/></svg>`,
    },
    {
      id: 'hermes',
      name: { de: 'Ερμής — Hermes', en: 'Ερμής — Hermes' },
      short: { de: 'Hermes', en: 'Hermes' },
      title: { de: 'Göttlicher Bote', en: 'Divine Messenger' },
      msg: { de: 'Hermes öffnet dir neue Pforten.', en: 'Hermes opens new gates for you.' },
      color: '#D4A574', glow: 'rgba(212,165,116,.4)', cls: 'ol-hermes', isReferral: true,
      svg: `<svg viewBox="0 0 60 60" width="60" height="60"><circle cx="30" cy="30" r="26" fill="none" stroke="#D4A574" stroke-width="1" opacity=".4"/><line x1="30" y1="14" x2="30" y2="48" stroke="#D4A574" stroke-width="1.5"/><path d="M30 17 Q22 12 15 17 Q22 22 30 17z" fill="rgba(212,165,116,.3)" stroke="#D4A574" stroke-width=".9"/><path d="M30 17 Q38 12 45 17 Q38 22 30 17z" fill="rgba(212,165,116,.3)" stroke="#D4A574" stroke-width=".9"/><path d="M30 23 Q26 29 30 35 Q34 41 30 47" fill="none" stroke="#D4A574" stroke-width="1.2"/><path d="M30 23 Q34 29 30 35 Q26 41 30 47" fill="none" stroke="#D4A574" stroke-width="1.2"/></svg>`,
    },
    // Future gods — add here without changing game logic:
    // { id: 'demeter', ... },
    // { id: 'dionysus', ... },
    // { id: 'poseidon', ... },
    // { id: 'hephaestus', ... },
  ];

  // ── REWARDS ───────────────────────────────
  // weights sum to 100 for easy admin display
  const REWARDS = [
    { id: 'dr50', type: 'points', pts: 50, label: { de: '50 Olympische Drachmen', en: '50 Olympic Drachmai' }, w: 30, minOrder: 0, pfx: null },
    { id: 'd5', type: 'percent', val: 5, label: { de: '5% Rabatt', en: '5% Discount' }, w: 25, minOrder: 0, pfx: 'OLYMP5', exp: '2026-12-31' },
    { id: 'd10', type: 'percent', val: 10, label: { de: '10% Rabatt', en: '10% Discount' }, w: 18, minOrder: 0, pfx: 'OLYMP10', exp: '2026-12-31' },
    { id: 'ship', type: 'shipping', label: { de: 'Gratis Versand ab CHF 60', en: 'Free Shipping from CHF 60' }, w: 12, minOrder: 60, pfx: 'SHIP', exp: '2026-12-31' },
    { id: 'gift', type: 'product', label: { de: 'Gratis Produkt ab CHF 50', en: 'Free Product from CHF 50' }, w: 8, minOrder: 50, pfx: 'GIFT', exp: '2026-12-31' },
    { id: 'd15', type: 'percent', val: 15, label: { de: '15% Rabatt', en: '15% Discount' }, w: 5, minOrder: 0, pfx: 'OLYMP15', exp: '2026-12-31' },
    { id: 'box', type: 'box', label: { de: 'Griechische Geschenkbox', en: 'Greek Gift Box' }, w: 2, minOrder: 0, pfx: 'GIFTBOX', exp: '2026-12-31' },
  ];

  // ── QUIZ ──────────────────────────────────
  const QUIZ = [
    {
      q: { de: 'Welche griechische Region ist für Kalamata-Oliven bekannt?', en: 'Which Greek region is known for Kalamata olives?' },
      opts: { de: ['Peloponnes', 'Kreta', 'Attika', 'Mazedonien'], en: ['Peloponnese', 'Crete', 'Attica', 'Macedonia'] },
      correct: 0,
      hint: { de: 'Diese Region liegt im südlichen Griechenland.', en: 'This region is in southern Greece.' }
    },
    {
      q: { de: 'Von welcher Insel stammt das einzigartige griechische Mastix-Harz?', en: 'From which island does the unique Greek mastic resin come?' },
      opts: { de: ['Chios', 'Lesbos', 'Samos', 'Rhodos'], en: ['Chios', 'Lesbos', 'Samos', 'Rhodes'] },
      correct: 0,
      hint: { de: 'Diese Insel liegt in der östlichen Ägäis.', en: 'This island is in the eastern Aegean.' }
    },
    {
      q: { de: 'Welches ist das Herkunftsgebiet des geschützten griechischen Safrans "Krokos"?', en: 'What is the origin of the protected Greek saffron "Krokos"?' },
      opts: { de: ['Kozani', 'Thessaloniki', 'Athen', 'Ioannina'], en: ['Kozani', 'Thessaloniki', 'Athens', 'Ioannina'] },
      correct: 0,
      hint: { de: 'Diese Stadt liegt in Nordgriechenland.', en: 'This city is in northern Greece.' }
    },
    {
      q: { de: 'Welcher griechische Käse hat eine geschützte Ursprungsbezeichnung (PDO)?', en: 'Which Greek cheese has Protected Designation of Origin?' },
      opts: { de: ['Feta', 'Halloumi', 'Manouri', 'Kasseri'], en: ['Feta', 'Halloumi', 'Manouri', 'Kasseri'] },
      correct: 0,
      hint: { de: 'Er darf nur aus bestimmten Regionen Griechenlands stammen.', en: 'It must come from specific regions of Greece only.' }
    },
    {
      q: { de: 'Für welchen griechischen Honig ist der Berg Hymettus bei Athen bekannt?', en: 'For which type of Greek honey is Mount Hymettus near Athens famous?' },
      opts: { de: ['Thymian-Honig', 'Orangen-Honig', 'Pinien-Honig', 'Lavendel-Honig'], en: ['Thyme honey', 'Orange honey', 'Pine honey', 'Lavender honey'] },
      correct: 0,
      hint: { de: 'Ein Kraut das auf dem trockenen Mittelmeerberg wächst.', en: 'An herb that grows on the dry Mediterranean mountain.' }
    },
  ];

  // ── STATE ─────────────────────────────────
  const SK = 'lg_olympus_v1' + (CUSTOMER_ID ? '_' + CUSTOMER_ID : '');
  let S = { opps: 3, drachmai: 0, plays: 0, rewards: [], lastDate: '', lang: LOCALE, refCode: '', soundOn: false };
  let GS = { screen: 'ol-sIntro', godAssign: [], selectedDoor: -1, selectedGod: null, reward: null, quizQ: null, adminClicks: 0 };
  let quizAnswered = false;

  function loadState() {
    try { const d = JSON.parse(localStorage.getItem(SK) || '{}'); Object.assign(S, d); } catch (e) {}
    const today = new Date().toDateString();
    if (S.lastDate !== today) {
      if (S.lastDate) S.opps = Math.min(3, S.opps + 1); // +1 daily
      S.lastDate = today;
      save();
    }
    if (!S.refCode) {
      S.refCode = (CUSTOMER_ID || Math.random().toString(36).substr(2, 4).toUpperCase()) + '-' + Math.random().toString(36).substr(2, 4).toUpperCase();
      save();
    }
    // Sync lang from Shopify locale
    if (LOCALE === 'de' || LOCALE === 'en') S.lang = LOCALE;
  }
  function save() { try { localStorage.setItem(SK, JSON.stringify(S)); } catch (e) {} }

  // ── i18n ──────────────────────────────────
  const t = k => (T[S.lang] || T.de)[k] || (T.de)[k] || k;

  function applyTranslations() {
    document.querySelectorAll('[data-ol-t]').forEach(el => {
      const k = el.getAttribute('data-ol-t');
      if (T[S.lang][k] !== undefined) el.textContent = T[S.lang][k];
    });
    document.getElementById('ol-lDE')?.classList.toggle('ol-on', S.lang === 'de');
    document.getElementById('ol-lEN')?.classList.toggle('ol-on', S.lang === 'en');
  }

  function setLang(l) {
    S.lang = l; save();
    applyTranslations();
    renderDoors();
    updateOpps();
  }
  window.olSetLang = setLang;

  // ── STARS ─────────────────────────────────
  function initStars() {
    const cv = document.getElementById('ol-stars');
    if (!cv) return;
    const ctx = cv.getContext('2d');
    let stars = [], clouds = [];

    function resize() {
      const wrap = document.getElementById('ol-game-wrap');
      cv.width = wrap ? wrap.offsetWidth : window.innerWidth;
      cv.height = wrap ? wrap.offsetHeight : window.innerHeight;
    }
    function mkStars() {
      stars = [];
      for (let i = 0; i < 160; i++) stars.push({ x: Math.random() * cv.width, y: Math.random() * cv.height * 0.7, r: Math.random() * 1.4 + 0.2, t: Math.random() * Math.PI * 2 });
      clouds = [];
      for (let i = 0; i < 5; i++) clouds.push({ x: Math.random() * cv.width, y: Math.random() * cv.height * 0.35 + 20, w: Math.random() * 180 + 110, h: Math.random() * 45 + 22, a: 0.04 + Math.random() * 0.05, dx: (Math.random() - 0.5) * 0.15 });
    }
    function draw() {
      ctx.clearRect(0, 0, cv.width, cv.height);
      clouds.forEach(c => {
        ctx.save(); ctx.globalAlpha = c.a;
        const g = ctx.createRadialGradient(c.x, c.y, 0, c.x, c.y, c.w / 2);
        g.addColorStop(0, 'rgba(200,210,235,.85)'); g.addColorStop(1, 'transparent');
        ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(c.x, c.y, c.w / 2, c.h / 2, 0, 0, Math.PI * 2); ctx.fill();
        ctx.restore();
        c.x += c.dx;
        if (c.x < -c.w) c.x = cv.width + c.w;
        if (c.x > cv.width + c.w) c.x = -c.w;
      });
      stars.forEach(s => {
        s.t += 0.02;
        const a = 0.2 + 0.6 * (0.5 + 0.5 * Math.sin(s.t));
        ctx.save(); ctx.globalAlpha = a; ctx.fillStyle = '#fff';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); ctx.fill(); ctx.restore();
      });
      requestAnimationFrame(draw);
    }
    resize(); mkStars(); draw();
    const ro = new ResizeObserver(() => { resize(); mkStars(); });
    const wrap = document.getElementById('ol-game-wrap');
    if (wrap) ro.observe(wrap);
  }

  // ── UI HELPERS ────────────────────────────
  function showScreen(id) {
    document.querySelectorAll('.ol-sc').forEach(s => s.classList.remove('act'));
    const el = document.getElementById(id);
    if (el) el.classList.add('act');
    GS.screen = id;
    const legal = document.getElementById('ol-legal');
    if (legal) legal.style.display = (id === 'ol-sIntro' || id === 'ol-sSelect') ? '' : 'none';
  }

  function showToast(msg, dur = 2200) {
    const t = document.getElementById('ol-toast');
    if (!t) return;
    t.textContent = msg; t.classList.add('ol-show');
    setTimeout(() => t.classList.remove('ol-show'), dur);
  }

  function updateOpps() {
    const wrap = document.getElementById('ol-dots');
    if (!wrap) return;
    wrap.innerHTML = '';
    const total = Math.max(3, S.opps);
    for (let i = 0; i < total; i++) {
      const d = document.createElement('div');
      d.className = 'ol-dot' + (i >= S.opps ? ' ol-off' : '');
      wrap.appendChild(d);
    }
    const lbl = document.querySelector('[data-ol-t="divChances"]');
    if (lbl) lbl.textContent = `${S.opps} ${t('divChances')}`;
  }

  function toggleSound() {
    S.soundOn = !S.soundOn; save();
    const btn = document.getElementById('ol-soundBtn');
    if (btn) btn.textContent = S.soundOn ? '🔊' : '🔇';
  }
  window.olToggleSound = toggleSound;

  // ── REWARD ENGINE ─────────────────────────
  function weightedReward() {
    const total = REWARDS.reduce((s, r) => s + r.w, 0);
    let rand = Math.random() * total;
    for (const r of REWARDS) { rand -= r.w; if (rand <= 0) return r; }
    return REWARDS[0];
  }

  function genCode(pfx) {
    return pfx + '-' + Math.random().toString(36).substr(2, 6).toUpperCase();
  }

  /**
   * createShopifyDiscount — posts to a backend endpoint (Shopify app or custom function)
   * that calls the Admin API to create a real one-time discount code.
   * Wire up your own endpoint at DISCOUNT_ENDPOINT.
   * Falls back to a display-only generated code if no endpoint is configured.
   */
  async function createShopifyDiscount(reward, code) {
    if (!DISCOUNT_ENDPOINT) return code; // no backend → show generated code as-is
    try {
      const res = await fetch(DISCOUNT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          code,
          type: reward.type,
          value: reward.val || null,
          minOrder: reward.minOrder,
          expires: reward.exp,
          customerId: CUSTOMER_ID,
          customerEmail: CUSTOMER_EMAIL,
        }),
      });
      const data = await res.json();
      return data.code || code;
    } catch {
      return code;
    }
  }

  // ── DOORS ─────────────────────────────────
  function shuffle(a) { const b = [...a]; for (let i = b.length - 1; i > 0; i--) { const j = 0 | Math.random() * (i + 1); [b[i], b[j]] = [b[j], b[i]]; } return b; }

  function renderDoors() {
    const wrap = document.getElementById('ol-doorsWrap');
    if (!wrap) return;
    wrap.innerHTML = '';
    const availableGods = GODS.slice(); // future: filter by enabled in admin
    while (availableGods.length < 3) availableGods.push(...GODS); // pad if < 3
    const pool = shuffle(availableGods).slice(0, 3);
    GS.godAssign = pool.map(g => GODS.indexOf(g));
    const labels = t('doorLabel');

    pool.forEach((g, di) => {
      const dw = document.createElement('div');
      dw.className = 'ol-dw';
      dw.setAttribute('role', 'button');
      dw.setAttribute('tabindex', '0');
      dw.setAttribute('aria-label', `${labels[di]}`);
      dw.innerHTML = `
        <div class="ol-d-col-row"><div class="ol-d-cap"></div><div class="ol-d-cap"></div></div>
        <div class="ol-d-arch">
          <div class="ol-arch-glow"></div>
          <div class="ol-mystery"><span class="ol-mystery-mark" style="--d:${di * 0.4}s">Ω</span></div>
          <div class="ol-d-reveal">
            ${g.svg.replace('width="60" height="60"', 'width="36" height="36"')}
            <div class="ol-d-god-name">${g.short[S.lang]}</div>
          </div>
        </div>
        <div class="ol-d-body">
          <div class="ol-d-pan ol-d-pl"></div>
          <div class="ol-d-pan ol-d-pr"></div>
          <div class="ol-d-reveal" style="z-index:0;padding:0 8px">
            <div style="font-family:var(--ol-ff-d);font-size:9px;letter-spacing:.22em;color:${g.color};text-transform:uppercase;text-align:center">${g.short[S.lang]}</div>
          </div>
        </div>
        <div class="ol-d-base"><div class="ol-d-pillar"></div><div class="ol-d-pillar"></div></div>
        <div class="ol-d-num">${labels[di]}</div>`;

      dw.addEventListener('click', () => selectDoor(di));
      dw.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectDoor(di); } });
      wrap.appendChild(dw);
    });
  }

  function selectDoor(di) {
    if (S.opps <= 0) { showScreen('ol-sClosed'); return; }
    if (GS.selectedDoor !== -1) return;
    GS.selectedDoor = di;
    S.opps--; S.plays++; save();
    updateOpps();

    document.querySelectorAll('.ol-dw').forEach((d, i) => {
      if (i === di) d.classList.add('ol-opening');
      else { d.classList.add('ol-fading'); d.style.pointerEvents = 'none'; }
    });

    const godIdx = GS.godAssign[di];
    GS.selectedGod = GODS[godIdx];

    setTimeout(() => {
      GS.selectedDoor = -1;
      if (GS.selectedGod.hasQuiz) showQuiz();
      else if (GS.selectedGod.isReferral) showHermes();
      else { GS.reward = weightedReward(); GS.reward.generatedCode = GS.reward.pfx ? genCode(GS.reward.pfx) : null; recordReward(); showWin(); }
    }, 900);
  }

  function recordReward() {
    if (!GS.reward) return;
    S.rewards.push({ god: GS.selectedGod.id, reward: GS.reward.id, code: GS.reward.generatedCode, ts: Date.now() });
    if (GS.reward.type !== 'points') S.drachmai += 10;
    save();
    if (GS.reward.generatedCode) createShopifyDiscount(GS.reward, GS.reward.generatedCode); // fire & forget
  }

  // ── ATHENA QUIZ ───────────────────────────
  function showQuiz() {
    quizAnswered = false;
    const qi = 0 | Math.random() * QUIZ.length;
    GS.quizQ = QUIZ[qi];
    const qEl = document.getElementById('ol-quizQ');
    const optsEl = document.getElementById('ol-quizOpts');
    const hintEl = document.getElementById('ol-quizHint');
    if (!qEl || !optsEl || !hintEl) return;

    qEl.textContent = GS.quizQ.q[S.lang];
    optsEl.innerHTML = '';
    hintEl.style.display = 'none';

    const letters = ['A', 'B', 'C', 'D'];
    GS.quizQ.opts[S.lang].forEach((o, i) => {
      const btn = document.createElement('button');
      btn.className = 'ol-qopt';
      btn.innerHTML = `<span class="ol-qnum">${letters[i]}</span>${o}`;
      btn.addEventListener('click', () => answerQuiz(i, btn));
      optsEl.appendChild(btn);
    });
    showScreen('ol-sQuiz');
  }

  function answerQuiz(idx) {
    if (quizAnswered) return;
    quizAnswered = true;
    const correct = GS.quizQ.correct;
    document.querySelectorAll('.ol-qopt').forEach((b, i) => {
      b.disabled = true;
      if (i === correct) b.classList.add('ol-correct');
      else if (i === idx && idx !== correct) b.classList.add('ol-wrong');
    });
    const hintEl = document.getElementById('ol-quizHint');
    if (idx === correct) {
      if (hintEl) { hintEl.textContent = t('athenaMsg'); hintEl.style.display = 'block'; }
      GS.reward = REWARDS.find(r => r.id === 'd10') || REWARDS[2];
      S.drachmai += 100;
    } else {
      if (hintEl) { hintEl.textContent = GS.quizQ.hint[S.lang]; hintEl.style.display = 'block'; }
      GS.reward = REWARDS.find(r => r.id === 'dr50') || REWARDS[0];
      S.drachmai += 50;
    }
    GS.reward = { ...GS.reward, generatedCode: GS.reward.pfx ? genCode(GS.reward.pfx) : null };
    recordReward();
    setTimeout(showWin, 1600);
  }
  window.olAnswerQuiz = answerQuiz;

  // ── WIN SCREEN ────────────────────────────
  function showWin() {
    const g = GS.selectedGod;
    const r = GS.reward;
    const l = S.lang;

    const iconEl = document.getElementById('ol-winIcon');
    const godLbl = document.getElementById('ol-winGodLabel');
    const headline = document.getElementById('ol-winHeadline');
    const rewardEl = document.getElementById('ol-winReward');
    const drRow = document.getElementById('ol-drachmai-row');
    const codeBox = document.getElementById('ol-codeBox');
    const meta = document.getElementById('ol-winMeta');
    const pab = document.getElementById('ol-playAgainBtn');
    const codeVal = document.getElementById('ol-codeVal');
    const copyBtn = document.getElementById('ol-copyBtn');

    if (iconEl) iconEl.innerHTML = g.svg;
    if (godLbl) { godLbl.textContent = g.name[l]; godLbl.style.color = g.color; }
    if (headline) headline.textContent = g.msg[l];
    if (rewardEl) { rewardEl.textContent = r.label[l]; rewardEl.style.color = g.color; }

    if (r.type === 'points') {
      if (drRow) { drRow.style.display = 'flex'; document.getElementById('ol-drachmaiText').textContent = `+${r.pts} ${t('drachmai')} · ${t('drachmai').split(' ')[0] === 'Olympische' ? 'Gesamt' : 'Total'}: ${S.drachmai}`; }
      if (codeBox) codeBox.style.display = 'none';
      if (meta) meta.textContent = '';
    } else {
      if (drRow) drRow.style.display = 'none';
      if (codeBox) codeBox.style.display = 'flex';
      if (codeVal) codeVal.textContent = r.generatedCode || r.pfx;
      if (copyBtn) { copyBtn.textContent = t('copyLink'); copyBtn.classList.remove('ol-copied'); }
      const expDisplay = r.exp ? r.exp.split('-').reverse().join('.') : '31.12.2026';
      if (meta) {
        meta.innerHTML = r.minOrder > 0
          ? `${t('expiry')} ${expDisplay} · ${t('minOrder')} CHF ${r.minOrder}`
          : `${t('expiry')} ${expDisplay}`;
      }
    }

    if (pab) {
      if (S.opps > 0) {
        pab.style.display = '';
        pab.textContent = `${t('playAgain')} (${S.opps} ${t('chancesLeft')})`;
      } else {
        pab.style.display = 'none';
      }
    }
    showScreen('ol-sWin');
  }

  function copyCode() {
    const code = document.getElementById('ol-codeVal')?.textContent || '';
    navigator.clipboard.writeText(code).catch(() => {});
    const btn = document.getElementById('ol-copyBtn');
    if (btn) { btn.textContent = t('copied'); btn.classList.add('ol-copied'); }
    showToast(t('copied'));
    setTimeout(() => { if (btn) { btn.classList.remove('ol-copied'); btn.textContent = t('copyLink'); } }, 2500);
  }
  window.olCopyCode = copyCode;

  function shareReward() {
    const code = document.getElementById('ol-codeVal')?.textContent || '';
    const msg = `Ich habe bei LaGrecia.ch gespielt und gewonnen! Code: ${code} 🏺 ${SHOP_URL}/pages/olympus`;
    if (navigator.share) {
      navigator.share({ title: 'ΤΑ ΔΩΡΑ ΤΟΥ ΟΛΥΜΠΟΥ', text: msg, url: `${SHOP_URL}/pages/olympus` });
    } else {
      window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank');
    }
  }
  window.olShareReward = shareReward;

  // ── HERMES REFERRAL ───────────────────────
  function showHermes() {
    const link = `${SHOP_URL}/pages/olympus?ref=${S.refCode}`;
    const linkEl = document.getElementById('ol-refLinkTxt');
    if (linkEl) linkEl.textContent = link;
    showScreen('ol-sHermes');
  }
  window.olShowHermes = showHermes;

  function copyRefLink() {
    const link = `${SHOP_URL}/pages/olympus?ref=${S.refCode}`;
    navigator.clipboard.writeText(link).catch(() => {});
    showToast(t('copied'));
    const btn = document.getElementById('ol-copyRefBtn');
    if (btn) { btn.textContent = t('copied'); setTimeout(() => btn.textContent = t('copyLink'), 2200); }
  }
  window.olCopyRefLink = copyRefLink;

  function shareWhatsApp() {
    const link = encodeURIComponent(`${SHOP_URL}/pages/olympus?ref=${S.refCode}`);
    const msg = encodeURIComponent('Spiele "Τα Δώρα του Ολύμπου" bei LaGrecia.ch und gewinne griechische Delikatessen! 🏺 ');
    window.open(`https://wa.me/?text=${msg}${link}`, '_blank');
  }
  window.olShareWhatsApp = shareWhatsApp;

  function shareEmail() {
    const link = `${SHOP_URL}/pages/olympus?ref=${S.refCode}`;
    window.location.href = `mailto:?subject=${encodeURIComponent('Geschenke des Olymp bei LaGrecia.ch')}&body=${encodeURIComponent('Spiele jetzt und gewinne griechische Delikatessen!\n\n' + link)}`;
  }
  window.olShareEmail = shareEmail;

  // ── NAVIGATION ────────────────────────────
  function showSelect() {
    if (S.opps <= 0) { showScreen('ol-sClosed'); return; }
    renderDoors();
    showScreen('ol-sSelect');
  }
  window.olShowSelect = showSelect;

  function goShop() { window.location.href = SHOP_URL; }
  window.olGoShop = goShop;

  function showMyRewards() {
    if (!S.rewards.length) { showToast(S.lang === 'de' ? 'Noch keine Belohnungen.' : 'No rewards yet.'); return; }
    showToast(`${S.rewards.length} ${S.lang === 'de' ? 'Belohnung(en)' : 'reward(s)'} · ${S.drachmai} ${t('drachmai')}`, 3000);
  }
  window.olShowMyRewards = showMyRewards;

  function playAgain() {
    if (S.opps <= 0) { showScreen('ol-sClosed'); return; }
    GS.selectedGod = null; GS.reward = null;
    showSelect();
  }
  window.olPlayAgain = playAgain;

  // ── ADMIN ─────────────────────────────────
  function openAdmin() {
    const el = document.getElementById('ol-admin-overlay');
    if (el) el.classList.remove('ol-hide');
  }
  window.olOpenAdmin = openAdmin;

  function closeAdmin() {
    const el = document.getElementById('ol-admin-overlay');
    if (el) el.classList.add('ol-hide');
  }
  window.olCloseAdmin = closeAdmin;

  function toggleGameActive(checkbox) {
    const lbl = document.getElementById('ol-gameStatusLabel');
    if (lbl) lbl.textContent = checkbox.checked ? (S.lang === 'de' ? 'Aktiv' : 'Active') : (S.lang === 'de' ? 'Inaktiv' : 'Inactive');
  }
  window.olToggleGameActive = toggleGameActive;

  function exportCSV() {
    const rows = [['Zeit', 'Email', 'Gott', 'Belohnung', 'Code']];
    S.rewards.forEach(r => {
      const g = GODS.find(g => g.id === r.god);
      const rw = REWARDS.find(rw => rw.id === r.reward);
      rows.push([new Date(r.ts).toLocaleString(), CUSTOMER_EMAIL || '—', g?.short.de || r.god, rw?.label.de || r.reward, r.code || '—']);
    });
    const csv = rows.map(r => r.join(',')).join('\n');
    const a = document.createElement('a');
    a.href = 'data:text/csv,' + encodeURIComponent(csv);
    a.download = 'olympus-gewinner.csv';
    a.click();
    showToast('CSV exportiert');
  }
  window.olExportCSV = exportCSV;

  // ── REFERRAL DETECTION ────────────────────
  function checkReferral() {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref && ref !== S.refCode) {
      // A referred user — give them a bonus opportunity
      S.opps = Math.min(S.opps + 1, 6);
      save();
    }
  }

  // ── INIT ──────────────────────────────────
  function init() {
    loadState();
    checkReferral();
    applyTranslations();
    updateOpps();
    initStars();

    const soundBtn = document.getElementById('ol-soundBtn');
    if (soundBtn) soundBtn.textContent = S.soundOn ? '🔊' : '🔇';

    const refEl = document.getElementById('ol-refLinkTxt');
    if (refEl) refEl.textContent = `${SHOP_URL}/pages/olympus?ref=${S.refCode}`;

    // Brand click → admin (5 rapid clicks)
    const brand = document.getElementById('ol-brandClick');
    if (brand) {
      brand.addEventListener('click', () => {
        GS.adminClicks++;
        if (GS.adminClicks >= 5) { GS.adminClicks = 0; openAdmin(); }
        setTimeout(() => { GS.adminClicks = Math.max(0, GS.adminClicks - 1); }, 2000);
      });
    }

    // URL param admin
    if (location.search.includes('admin')) openAdmin();

    showScreen('ol-sIntro');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
